export default {
    context: {
        workspace: 'Add to work space',
        macrotrend: {
            any: 'Pin to macro-trend',
            specific: 'Pin to macro-trend "{title}"'
        }
    },
    tooltip: {
        addToWorkspaceOrMacrotrend: 'Add to work space or pin to macro-trend',
        addToMacrotrend: 'Pin to macro-trend',
        addToWorkspace: 'Add to work space',
        disabled: 'No micro-trends have been selected'
    },
    success: 'The micro-trend <strong>{title}</strong> was successfully pinned to the following macro-trends:'
}
